export enum HuseierneHouseContentsInsuranceType {
  HUSEIERNE_HOUSE_CONTENTS_STANDARD = "huseierneHouseContentsStandard",
}
